<template>
<div>
  <span class="tit">자원선택</span>
  <el-popover :width="800" placement="bottom" trigger="click" v-model="visibleRscPopover">
    <el-table-wrapper :max-height="400" :columns="columns" :data="tableData" row-class-name="c-pointer" :show-overflow-tooltip="false" :pagination="false" @cell-click="selectObjRscKey">
    </el-table-wrapper>
    <el-input :class="$style.pointer" style="width:calc(100% - 75px);" slot="reference" v-model="selectedObjRscKeyLabel" placeholder="자원을 선택해주십시오." readonly />
  </el-popover>
</div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import { getValueAfterCheckEmpty } from '@/utils/string';

export default {
  name: 'WObjRscKeySelectComponent',
  props: {
    rscInfoList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      visibleRscPopover: false,
      tableData: [],
      selectedObjRscKeyData: {},
      selectedObjRscKeyLabel: null,
      columns: [
        {
          prop: 'objName',
          label: '장비명',
          sortable: true,
        },
        {
          prop: 'managetypeName',
          label: '관리구분',
          sortable: true,
        },
        {
          prop: 'rsctypeName',
          label: '자원구분',
          sortable: true,
        },
        {
          prop: 'rscName',
          label: '자원',
          sortable: true,
        },
        {
          prop: 'rscKeyName',
          label: '자원키',
          sortable: true,
        },
      ],
    };
  },
  watch: {
    rscInfoList: {
      handler(value) {
        if (isEmpty(value)) {
          this.reset();
        } else {
          this.tableData = this.rscInfoList;
          if (!isEmpty(this.tableData)) {
            this.selectObjRscKey(this.tableData[0]);
          }
        }
      },
    },
  },
  methods: {
    isEmpty,
    selectObjRscKey(row) {
      this.selectedObjRscKeyData = row;
      this.selectedObjRscKeyLabel = `[${getValueAfterCheckEmpty(row.objName)}] ${getValueAfterCheckEmpty(row.managetypeName)} > ${getValueAfterCheckEmpty(row.rsctypeName)} > ${getValueAfterCheckEmpty(row.rscName)} (${getValueAfterCheckEmpty(
        row.rscKeyName,
      )})`;
      this.visibleRscPopover = false;
      this.$emit('select', this.selectedObjRscKeyData);
    },
    reset() {
      this.tableData = [];
      this.selectedObjRscKeyData = {};
      this.selectedObjRscKeyLabel = null;
      this.$emit('reset');
    },
  },
};
</script>

<style module>
.pointer input {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/ResourceSmartAnalyzerPopup/components/ObjRscKeySelectComponent.vue